import { createStore } from "vuex";
import createVuexPersistedState from "vuex-persistedstate";
import { LOCAL_STORAGE_KEY } from "@/utils/const";
import auth from "@/store/modules/auth";
import error from "./modules/error";
import user from "./modules/user";
import verification from "./modules/verification";
import recipientAccount from "./modules/recipient_account";
import subscription from "./modules/subscription";

export default createStore({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        auth,
        error,
        user,
        verification,
        recipientAccount,
        subscription,
    },
    plugins: [
        createVuexPersistedState({
            key: LOCAL_STORAGE_KEY,
            storage: window.localStorage,
            paths: ["auth"],
        }),
    ],
});
